import React from 'react';
import Contact from '../Contact/Contacts';
import Hero from '../Heros/Hero';
import Projects from '../Project/Projects';

const Homes = () => {
    return (
        <div>
            <Hero/>
            <Projects/>
            <Contact/>
        </div>
    );
};

export default Homes;